// extracted by mini-css-extract-plugin
export default {"wrapper":"mRJTCA","inSettingsPanel":"rotVEt","featuredLabel":"oskuk3","disabled":"xrMjA_","label":"k6avYQ"};